import React from 'react';
import styled from 'styled-components';
import { SvgProps } from './Svg/core';
import {
  LinkedInLogo,
  TwitterLogo,
  FacebookLogo,
  InstagramLogo,
} from './Svg/Icons';
import env from '../env';

const SocialContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`;

interface SocialLinkData {
  name: string;
  logo: React.FC<SvgProps>;
  link: string;
}

const SOCIAL_LINKS: SocialLinkData[] = [
  {
    name: 'LinkedIn',
    logo: LinkedInLogo,
    link: env.linkedin_url,
  },
  {
    name: 'Twitter',
    logo: TwitterLogo,
    link: env.twitter_url,
  },
  {
    name: 'Facebook',
    logo: FacebookLogo,
    link: env.facebook_url,
  },
  {
    name: 'Instagram',
    logo: InstagramLogo,
    link: env.instagram_url,
  },
];

const SocialLinks: React.FC = () => {
  return (
    <SocialContainer>
      {SOCIAL_LINKS.map((s) => (
        <SocialLink
          key={s.name}
          href={s.link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.name}
        >
          <s.logo />
        </SocialLink>
      ))}
    </SocialContainer>
  );
};

export default SocialLinks;
